const translations = {
  CONTACT_DEALER: {
    en: 'Contact this dealer',
    fr: 'Contacter ce concessionnaire',
    es: 'Contacte con este distribuidor',
  },
  FORM_ERROR_MANDATORY: {
    en: 'This field is mandatory',
    fr: 'Ce champ est obligatoire',
    es: 'Este campo es obligatorio',
  },
  FORM_ERROR_GLOBAL: {
    en: 'Incorrect field',
    fr: 'Champ incorrect',
    es: 'Campeón incorrecto',
  },
  FORM_ERROR_MAIL: {
    en: 'Incorrect email format',
    fr: 'Format d\'email incorrect',
    es: 'Formato incorrecto del correo electrónico',
  },
  FORM_ERROR_TEL: {
    en: 'Incorrect phone format',
    fr: 'Format de téléphone incorrect',
    es: 'Formato de teléfono incorrecto',
  },
  FORM_ERROR_DATE: {
    en: 'Incorrect date format',
    fr: 'Format de date incorrect',
    es: 'Formato de fecha incorrecto',
  },
  FORM_ERROR_PASSWORD: {
    en: 'Invalid password format',
    fr: 'Format du mot de passe invalide',
    es: 'Formato de contraseña incorrecto',
  },
  FORM_ERROR_PASSWORD2: {
    en: 'Both passwords must be identical',
    fr: 'Les deux mots de passe doivent être identiques',
    es: 'Las dos contraseñas deben ser idénticas',
  },
  FORM_ERROR_RADIO: {
    en: 'Please select a choice',
    fr: 'Veuillez sélectionner un choix',
    es: 'Seleccione una opción',
  },
  FORM_ERROR_SENDING: {
    en: 'Submission error',
    fr: 'Erreur lors de la soumission',
    es: 'Error de envío',
  },
  FORM_SUCCESS_SALON: {
    en: 'The request has been sent.',
    fr: 'La demande a bien été envoyée.',
    es: 'La solicitud ha sido enviada.',
  },
  FORM_SUCCESS_NEWSLETTER: {
    en: 'Thank you for your subscription.',
    fr: 'Merci pour votre inscription.',
    es: 'Gracias por inscribirse',
  },
  FORM_SUCCESS_CONTACT_INFO: {
    en: 'Thank you for your message.',
    fr: 'Merci pour votre message.',
    es: 'Gracias por su mensaje.',
  },
  INPUT_FILE_EMPTY: {
    en: 'No files selected',
    fr: 'Aucun fichier choisi',
    es: 'No hay archivos seleccionados',
  },
  NEWSROOM_PROGRESS: {
    en: 'You\'ve seen *current* out of *total* pieces of content',
    fr: 'Vous avez vu *current* contenus sur *total*',
    es: 'Ha visto *current* de cada *total* contenidos',
  },
  OFFERS_PROGRESS: {
    en: 'You\'ve seen *current* out of *total* jobs',
    fr: 'Vous avez vu *current* postes sur *total*',
    es: 'Ha visto *current* de cada *total* trabajos',
  },
  OFFERS_NO_RESULT: {
    en: 'There are no offers matching your search. Please try again with other criteria.',
    fr: 'Aucune offre ne correspond à votre recherche. Veuillez réessayer avec d\'autres critères.',
    es: 'No hay ofertas que coincidan con su búsqueda. Vuelve a intentarlo con otros criterios.',
  },
  FORM_COUNTRY: {
    en: 'Choose your country',
    fr: 'Choisissez un pays',
    es: 'Elija un país',
  },
  FORM_STATE: {
    en: 'Choose your home port',
    fr: "Choisissez votre port d’attache",
    es: 'Elija su puerto base',
  },
  PAGE_NAV_PRODUCT_VIDEO_WRAP: {en: 'Video', fr: 'Vidéos', es: 'Video'},
  PAGE_NAV_PRODUCT_FEATURES: {en: 'Specifications', fr: 'Spécifications', es: 'Especificación'},
  PAGE_NAV_PRODUCT_SPACES: {en: 'Photos', fr: 'Photos', es: 'Foto'},
  PAGE_NAV_PRODUCT_MILLESIME: {en: 'Millesime', fr: 'Millésime', es: 'Millesime'},
  PAGE_NAV_PRODUCT_VIRTUAL_TOUR: {en: '360° Tour', fr: 'Visite 360°', es: '360° visita'},
  PAGE_NAV_PRODUCT_CONFIG_3D: {en: '3D Configurator', fr: 'Configurateur 3D', es: 'Configurador 3D'},
  PAGE_NAV_ODSEA_SOLUTIONS: {en: 'Assets', fr: 'Atout ODSea+', es: 'Ventajas'},
  PAGE_NAV_ODSEA_RENEWABLE_ENERGIES: {en: 'Renewable energies', fr: 'Energies renouvelables', es: 'Energías renovables'},
  PAGE_NAV_ODSEA_SCRIPTS: {en: 'Cruising scenarios', fr: 'Scénarios de croisières', es: 'Escenarios de crucero'},
  PAGE_NAV_ODSEA_OTHER_PRODUCTS: {en: 'Hybrid catamarans', fr: 'Catamarans hybrides', es: 'Catamaranes híbridos'},
  PAGE_NAV_CARREERS_VIDEOS: {fr: 'Vidéos Métiers'},
  PAGE_NAV_CARREERS_OFFRES: {fr: 'Nos offres'},
  PAGE_NAV_CARREERS_FORMATIONS: {fr: 'Nos formations ITN'}
}

export default (key, lang) => {
  const locale = lang || document.querySelector('html').getAttribute('lang')
  const string =
    translations[key] && translations[key][locale]
      ? translations[key][locale]
      : 'missing translation'
  return string
}
